import { cambiaLingua, leggiLingua, LINGUE, t } from '../i18n/lingua'
import type { Lingua } from '../i18n/lingua'

/**
 * Selettore della lingua, accanto a quello del tema.
 *
 * ## Perché ricarica la pagina
 *
 * Perché la lingua cambia due volte nella vita di un utente, e un contesto
 * reattivo attraverso cinquantotto componenti sarebbe un meccanismo che si può
 * sbagliare in cinquantotto punti per un evento che non capita. Ricaricare è
 * grossolano e non sbaglia.
 *
 * ## Perché i nomi non sono tradotti
 *
 * «Italiano» e «English» restano tali in ogni lingua: chi cerca la propria in
 * un elenco la cerca come la chiama lui, e «Inglese» non aiuta chi non sa
 * l'italiano — che è esattamente la persona che sta usando questo menu.
 */
export default function LinguaSwitch({
  variant = 'topbar',
}: {
  variant?: 'topbar' | 'inline'
}) {
  const corrente = leggiLingua()

  return (
    <select
      className={variant === 'topbar' ? 'topbar__select' : undefined}
      value={corrente}
      onChange={(e) => cambiaLingua(e.target.value as Lingua)}
      aria-label={t('Lingua della console')}
      title={t('Lingua della console')}
    >
      {LINGUE.map((opzione) => (
        <option key={opzione.value} value={opzione.value}>
          {opzione.label}
        </option>
      ))}
    </select>
  )
}
